import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../../config';
import {
	AugerPurgeCommand,
	AugerPurgeConfig,
	AugerPurgePatch,
	normalizeAugerPurgeError
} from './auger-purge.util';

export interface AugerPurgeCommandResult {
	command_id: string;
	machine_id: string;
	status: string;
	sent_at: string;
	payload: any;
}

@Injectable({
	providedIn: 'root'
})
export class AugerPurgeHttpService {
	private apiName: string;

	constructor(private configService: ConfigService) {
		this.apiName = this.configService.get('host');
	}

	getConfig(machineId: string): Observable<AugerPurgeConfig> {
		return new Observable((observer: any) => {
			const path = '/dashboard/auger-purge/config/' + encodeURIComponent(machineId);
			API.get(this.apiName, path, { response: false }).then(response => {
				observer.next(response.data);
				observer.complete();
			}).catch(error => {
				observer.error(normalizeAugerPurgeError(error));
			});
		});
	}

	setConfig(patch: AugerPurgePatch): Observable<AugerPurgeCommandResult> {
		return new Observable((observer: any) => {
			API.patch(this.apiName, '/dashboard/auger-purge/config', { body: patch }).then(response => {
				observer.next(response.data);
				observer.complete();
			}).catch(error => {
				observer.error(normalizeAugerPurgeError(error));
			});
		});
	}

	getCommand(commandId: string): Observable<AugerPurgeCommand> {
		return new Observable((observer: any) => {
			const path = '/dashboard/auger-purge/commands/' + encodeURIComponent(commandId);
			API.get(this.apiName, path, { response: false }).then(response => {
				observer.next(response.data);
				observer.complete();
			}).catch(error => {
				observer.error(normalizeAugerPurgeError(error));
			});
		});
	}
}
